import { createFileRoute } from "@tanstack/react-router";
import { accountPageQueryOptions } from "@/features/account/records";
import { AccountPage } from "@/features/account";
import { AccountError, AccountPending } from "@/features/account/navigation";

export const Route = createFileRoute("/_site/account/")({
  loader: ({ context }) =>
    context.queryClient.fetchQuery(accountPageQueryOptions()),
  staleTime: 0,
  gcTime: 0,
  pendingComponent: AccountPending,
  errorComponent: AccountError,
  component: () => <AccountPage data={Route.useLoaderData()} />,
});
